<template>
  <v-text-field
    v-model="items.value"
    class="mb-2"
    color="primary"
    :label="getLabel(paramValues.label)"
    variant="outlined"
    density="compact"
    :rules="items.required ? valueRules : []"
    @drop="onDrop($event, items, 'value')"
    :required="items.required || false"
    :clearable="true"
    @click:clear="cleanValue"
    :hint="items.description"
    :persistent-hint="true"
    :hidden="items.hidden || false"
  ></v-text-field>
  <!-- This slot renders all components (if any) requested by Operator from BE via the 'dynamicParams' property of userData -->
  <slot name="dynamicParam" :content="state.content"></slot>
</template>

<script>
import { inject, toRefs, reactive, watch } from "vue";
import {
  drop,
  checkDrop,
  updateParameters,
  capitalizeFirstLetter,
} from "@/mixins/common-utils.js";
import { useI18n } from "vue-i18n";

export default {
  props: ["paramValues"],
  emits: ["bindInput"],
  setup(props, ctx) {
    const { t, te } = useI18n();
    const formData = inject("formData");
    const parameters = JSON.parse(JSON.stringify(props.paramValues));

    if (!parameters.value) {
      parameters.value = props.paramValues.defaultValue //Some operators can have a default value
        ? props.paramValues.defaultValue
        : "";
    }
    //Resets input linked variables when text-field icon clean  is clicked
    function cleanValue() {
      items.value.value = null;
      content.value = null;
    }

    const getLabel = (label) => {
      const labelKey = "labels." + label.toLowerCase().replace(/\s+/g, "-");
      return te(labelKey) ? t(labelKey) : label;
    };

    const valueRules = [
      (v) =>
        !!v ||
        t("strings.value-is-required", {
          type:
            capitalizeFirstLetter(props.paramValues.datatype) ||
            t("strings.a-value"),
        }),
    ];

    const onDrop = (event, item, targetName) => {
      event.stopPropagation();
      try {
        if (
          items.value.datatype?.split(",").includes(checkDrop(event)) ||
          items.value.datatype === "any" ||
          !items.value.datatype
        ) {
          drop(event, targetName, item);
          //Get real value of dropped element
          content.value = JSON.parse(event.dataTransfer.getData("text"))[1];
          valid.value = true;
        }
      } catch (error) {
        console.error("Error performing onDrop: ", error);
      }
    };

    const state = reactive({
      valid: inject("valid"),
      items: parameters,
      content: null,
    });
    const { valid, items, content } = toRefs(state);

    watch(
      items,
      (newItems) => {
        if (formData.parameters) {
          formData.parameters = updateParameters(newItems, formData.parameters);
        }
        //Emit real value of dropped element
        if (newItems.valuesTo || newItems.hasinnerprocess) {
          try {
            ctx.emit("bindInput", content.value, newItems.valuesTo || "source");
          } catch (error) {
            console.error("Error performing emit bindInput: ", error);
          }
        }
      },
      { deep: true },
    );
    return {
      onDrop,
      capitalizeFirstLetter,
      valid,
      items,
      valueRules,
      state,
      cleanValue,
      getLabel,
    };
  },
};
</script>
